import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import router from '@/router';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
        id:null,
        email:'',
        is_admin:false,
		is_business_admin:false,
    },
    authInitialized:false,
    intendedUrl:'',

    projects:[],
    templates:[],
    blocks:[],
    colorPresets:[],
    project:{
    	pages:[]
    },
      pages:[],
      tables:[],
      fonts:{},
        page:{},
    loading: 0,
    loadingMessage: '',
    tablePosts:{},
  },
  mutations: {
    startLoading(state) {
      state.loading += 1;
    },
    stopLoading(state) {
      if(state.loading>0) state.loading -= 1;
    },
    setLoadingMessage(state, payload) {
      state.loadingMessage = payload;
    },
    setIntendedUrl (state,payload) {
      state.intendedUrl = payload;
    },
    authInitialized (state) {
      state.authInitialized = true;
    },
    setUser (state,payload) {
      state.user = payload;
    },
    setTemplates (state,payload) {
      state.templates = payload;
    },
    setBlocks (state,payload) {
      state.blocks = payload;
    },

    setProject (state,payload) {
      state.project = payload;
    },
    setPages (state,payload) {
      state.pages = payload;
    },
    setTables (state,payload) {
      state.tables = payload;
    },
    setFonts (state,payload) {
      state.fonts = payload;
    },
    setPage (state,payload) {
      state.page = payload;
    },
    setColorPresets (state,payload) {
      state.colorPresets = payload;
    },
    setTablePosts(state,payload){
        state.tablePosts[payload.query] = payload.data;
    }
  },
  actions: {
    startLoading({commit}){
      commit('startLoading')
    },
    stopLoading({commit}){
      commit('stopLoading')
      if(this.state.loading==0 && this.state.loadingMessage) {
        commit('setLoadingMessage','');
      }
    },
    setLoadingMessage({commit},{message}){
      commit('setLoadingMessage',message)
    },
    setUser ({commit},user) {
      commit('setUser',user)
    },
    setIntendedUrl ({commit},url) {
      commit('setIntendedUrl',url)
    },
    authInitialized ({commit},bool) {
      commit('authInitialized',bool)
    },
    setTemplates ({commit},templates) {
      commit('setTemplates',templates)
    },
    setBlocks ({commit},payload) {
      commit('setBlocks',payload)
    },
    setProject ({commit},payload) {
      commit('setProject',payload)
    },
    setPages ({commit},payload) {
      commit('setPages',payload)
    },
    setTables ({commit},payload) {
      commit('setTables',payload)
    },
    setFonts ({commit},payload) {
      commit('setFonts',payload)
    },
    setPage ({commit},payload) {
      commit('setPage',payload)
    },
    setColorPresets ({commit},payload) {
      commit('setColorPresets',payload)
    },

    getColorPresets(){
      if(!iframeDom || !iframeDom.rootElm) return;

      var foundcolors = iframeDom.rootElm.innerHTML.match(/(#[0-9a-f]{3,6}|rgba?\([^)]+\))/ig)
      //Default colors first
      foundcolors.unshift('#333333');
      foundcolors.unshift('#F1F1F1');
      foundcolors.unshift('#FFFFFF');
      foundcolors.unshift('#000000');
      foundcolors.unshift('transparent');

      //make unique
      foundcolors  = [...new Set(foundcolors)];

      foundcolors = foundcolors.map(color=>{
          //transparent when alpha 0
          color = color.replace(/rgba.*,0\)/i,'transparent');

          //rgba to hex when alpha 1
          var match = color.match(/rgba\((.),(.),(.),1\)$/i);
          if(match){
              color = this.rgbToHex(parseInt(match[1]),parseInt(match[2]),parseInt(match[3]));
          }

          //333 to 333333
          var match = color.match(/#(.)(.)(.)$/);
          if(match){
              color = '#'+match[1]+match[1]+match[2]+match[2]+match[3]+match[3];
          }

          //uppercase
          if(color.match(/^#/)){
              color = color.toUpperCase();
          }

          return  color;
      })


      //unique
      foundcolors = [...new Set(foundcolors)];
      this.dispatch('setColorPresets',foundcolors);

    },

    getTemplates(){
      axios({
        url: '/api/templates',
      }).then((res) => {
        this.dispatch('setTemplates',res.data);
      });
		},
    getBlocks(){
      axios({
        url: '/api/block-categories/blocks',
      }).then((res) => {
        this.dispatch('setBlocks',res.data);
      });
    },
    getFonts({},meta){
      if(!meta || !meta.fonts) return;
			var fonts = meta.fonts;
			if(meta.customFonts){
				fonts = [...fonts,...meta.customFonts]
			}
      this.dispatch('setFonts',fonts);
    },
    getProject({},project_id){
			// this.dispatch('setProject',{id:project_id});
      return axios({
        url: '/api/projects/'+project_id,
      }).then((res) => {
        this.dispatch('setProject',res.data);
        this.dispatch('setPages',res.data.pages);
        this.dispatch('setTables',res.data.tables);
        this.dispatch('setFonts',[]);
        this.dispatch('getFonts',res.data.meta);
      });
		},
  },

  getters: {
    isAuthenticated:(state) => state.authInitialized && state.user &&  state.user.id,
    templates:(state) => state.templates,
    allblocks:(state) => state.blocks,
    blocks:(state) => state.blocks,
    colorPresets:(state) => state.colorPresets,
    project:(state) => state.project,
		tables:(state) => state.tables,
		tablePosts:(state) => (query) => {

			var table = query.dbtable;
			if(!table) return false;
			var queryString = '';
			for(var k in query){
				queryString = (queryString?queryString+'&':'')+`${k}=${query[k]}`;
			}
			var url = '/api/project/'+state.project.id+'/db/'+table+'/data';
			if(queryString) url += '?'+queryString;

			if(state.tablePosts[queryString]) return state.tablePosts[queryString];
			return axios(url).then((res) => {
					state.tablePosts[queryString] = res.data;
					return res.data;
			});

		},
    pages:(state) => state.pages,
    fonts:(state) => state.fonts,
    page:(state) => state.page,
    user:(state) => state.user,
  }
})
